module.exports = __webpack_public_path__ + "img/success_stories.fd313eb2.svg";